import axios from "axios";
import { handleRuntimeAccessError } from "./runtimeAccess";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Student session is carried by the httpOnly `student_access_token` cookie — a distinct
// cookie name from staff/parent so all three sessions can coexist in one browser.
const sapi = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

sapi.interceptors.response.use(
  (response) => response,
  (error) => {
    handleRuntimeAccessError(error);
    return Promise.reject(error);
  }
);

export default sapi;
